export function advanceRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_ADVANCE_START":           
        case "CREATE_SUPPLIER_ADVANCE_START":           
        case "FETCH_ADVANCES_START":                                 
        case "RECALC_ADVANCES_START":                                 
        case "UPDATE_ADVANCE_START":                                 
        case "DELETE_SUPPLIER_ADVANCE_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_ADVANCE_FULFILLED":           
        case "CREATE_SUPPLIER_ADVANCE_FULFILLED":           
        case "FETCH_ADVANCES_FULFILLED":                                 
        case "RECALC_ADVANCES_FULFILLED":                                 
        case "UPDATE_ADVANCE_FULFILLED":                                 
        case "DELETE_SUPPLIER_ADVANCE_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_ADVANCE_ERROR":
        case "CREATE_SUPPLIER_ADVANCE_ERROR":
        case "FETCH_ADVANCES_ERROR":
        case "RECALC_ADVANCES_ERROR":
        case "UPDATE_ADVANCE_ERROR":
        case "DELETE_SUPPLIER_ADVANCE_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}